export default {
    routerName: '图片管理',
    pic: {
        searchName: '检索条件',
        name: '图片名',
        status: '状态',
        open: '启用',
        close: '停用',
        sortOrder: '排序',
        createTime: '创建时间',
        createStartTime: '创建开始时间',
        createEndTime: '创建结束时间',
        searchButton: '搜索',
    },
    table: {
        id: 'ID',
        name: '图片名',
        thumb: '缩略图',
        sortOrder: '排序',
        createBy: '创建者',
        createTime: '创建时间',
        status: '状态',
    },
};
